export class XMLState {
	constructor(initialXML) {
		this.parser = new DOMParser();
		this.serializer = new XMLSerializer();
		this.doc = this.parser.parseFromString(initialXML, "text/xml");
	}

	_triggerUpdate() {
		const event = new CustomEvent('state-update', {
			detail: this.serializer.serializeToString(this.doc)
		});
		window.dispatchEvent(event);
	}

	update(newXML)
	{
		this.doc = this.parser.parseFromString(newXML, "text/xml");
	}

	serialize() {
		return this.serializer.serializeToString(this.doc);
	}

	evaluateXPath(xpath) {
		const result = this.doc.evaluate(
			xpath,
			this.doc,
			null,
			XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
			null
		);
		
		const nodes = [];
		for(let i = 0; i < result.snapshotLength; i++) {
			nodes.push(result.snapshotItem(i));
		}
		return nodes;
	}
}